<p-floatLabel>
  <p-select #externalSystemelector
        id="externalSystemSelector"
        name="externalSystemSelector"
        [options]="externalSystems"
        [(ngModel)]="selectedExternalSystem"
        [showClear]="true"
        [checkmark]="true"
        [filter]="true"
        styleClass="w-100"
        [disabled]="isDisabled"
        (onChange)="onSelected()"
        optionLabel="name">
    <ng-template let-option pTemplate="item">
      {{ option?.name }}
    </ng-template>
  </p-select>
  <label for="externalSystemSelector">
    <app-label-content [isRequired]="isRequired">
      {{ l('::ExternalSystem') }}
    </app-label-content>
  </label>
</p-floatLabel>